var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalfGoldStarIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 1l2.582 7.946h8.355l-6.76 4.911 2.582 7.947-6.759-4.911-6.76 4.91 2.582-7.946-6.76-4.91h8.356L11.5 1z",
    fill: "#FFC40D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "half-gold-star-icon_inline_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 14,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M12 0h14v22H12z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#half-gold-star-icon_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 1l2.582 7.946h8.355l-6.76 4.911 2.582 7.947-6.759-4.911-6.76 4.91 2.582-7.946-6.76-4.91h8.356L11.5 1z",
    fill: "#BDBDBD"
  }))));
}
export default SvgHalfGoldStarIconinline;